import React from "react";
import { cn } from "../../lib/utils";

// Layout wrapper for portfolio sections with a subtle glitch grid vibe

export function SectionShell({ id, title, kicker, children, className }) {
  return (
    <section
      id={id}
      className={cn(
        "scroll-mt-24 border-b border-slate-800/70 bg-black/40 backdrop-blur-sm",
        className
      )}
    >
      <div className="mx-auto max-w-5xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
        {(title || kicker) && (
          <header className="mb-8 flex flex-col gap-2">
            {kicker && (
              <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-cyan-300">
                {kicker}
              </p>
            )}
            {title && (
              <h2 className="text-2xl font-semibold tracking-tight text-slate-50 sm:text-3xl">
                <span className="mr-2 font-mono text-xs text-pink-400/80">//</span>
                {title}
              </h2>
            )}
          </header>
        )}
        {children}
      </div>
    </section>
  );
}

export default SectionShell;
